export default __webpack_public_path__ + "static/media/SD.1979436b.svg";